
export type ConfigResponseType = {
    placementId: string;
    group: string;
}

export enum BannerType {
    // Баннер в списке после 1-го сниппета
    CL_SEARCH_1_DESKTOP,
    CL_SEARCH_1_TOUCH,

    // Баннер в списке после 8-го сниппета
    CL_SEARCH_2_DESKTOP,
    CL_SEARCH_2_TOUCH,

    // Баннер в карточке оффера справа
    CL_OFFER_RIGHT_DESKTOP,
    CL_OFFER_RIGHT_TOUCH,

    // Баннер в карточке оффера снизу
    CL_OFFER_BOTTOM_DESKTOP,
    CL_OFFER_BOTTOM_TOUCH
}

/*
    Баннеры для Самолета:
    - https://jira.m2.ru/browse/NB-6110
*/

export const getBannerConfig = (type: BannerType): ConfigResponseType => {
    switch (type) {
        case BannerType.CL_SEARCH_1_DESKTOP:
        case BannerType.CL_SEARCH_1_TOUCH:
            return {
                placementId: 'search-banner-nb-1',
                group: 'serp'
            };

        case BannerType.CL_SEARCH_2_DESKTOP:
        case BannerType.CL_SEARCH_2_TOUCH:
            return {
                placementId: 'search-banner-nb-2',
                group: 'serp'
            };

        case BannerType.CL_OFFER_RIGHT_DESKTOP:
        case BannerType.CL_OFFER_RIGHT_TOUCH:
            return {
                placementId: 'offer-page-side',
                group: 'card'
            };

        case BannerType.CL_OFFER_BOTTOM_DESKTOP:
        case BannerType.CL_OFFER_BOTTOM_TOUCH:
            return {
                placementId: 'offer-page-bottom',
                group: 'card'
            };

        default:
            return {
                placementId: '',
                group: '',
            };
    }
};
